// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";
// Mobuis icon with  fill="currentColor"
const Star: React.FC = () => {
    return (
        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.99984 0.666504C8.25358 0.666504 8.48533 0.810415 8.59764 1.03773L10.5027 4.89346L14.7629 5.51556C15.0139 5.55222 15.2224 5.72806 15.3006 5.96916C15.3789 6.21027 15.3134 6.47486 15.1316 6.65171L12.0495 9.65086L12.7769 13.8879C12.8198 14.1378 12.717 14.3903 12.5116 14.5393C12.3063 14.6883 12.0341 14.708 11.8095 14.59L7.99984 12.5884L4.19015 14.59C3.96554 14.708 3.69334 14.6883 3.48803 14.5393C3.28271 14.3903 3.17988 14.1378 3.22278 13.8879L3.95017 9.65086L0.868034 6.65171C0.686289 6.47486 0.620774 6.21027 0.699026 5.96916C0.777277 5.72806 0.98573 5.55222 1.23677 5.51556L5.497 4.89346L7.40203 1.03773C7.51435 0.810415 7.74609 0.666504 7.99984 0.666504ZM7.99984 2.83727L6.53765 5.7967C6.44062 5.99308 6.25316 6.12925 6.03626 6.16093L2.76546 6.63855L5.13167 8.94105C5.28892 9.09407 5.36069 9.31461 5.32358 9.53076L4.7653 12.7827L7.68954 11.2464C7.88379 11.1443 8.11588 11.1443 8.31014 11.2464L11.2344 12.7827L10.6761 9.53076C10.639 9.31461 10.7108 9.09407 10.868 8.94105L13.2342 6.63855L9.96341 6.16093C9.74651 6.12925 9.55905 5.99308 9.46203 5.7967L7.99984 2.83727Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default React.memo(Star);
